import colors from "../../../appConfig/colors";

import { makeStyles } from "@material-ui/core/styles";

const QuestionnaireStyle = makeStyles((theme) => ({
	root: {
		display: "flex",
		height: "100%",
		[theme.breakpoints.down("xs")]: {
			flexDirection: "column",
		},
	},
	content: {
		overflow: "scroll",
		height: "100%",
		width: "100vw",
	},

	sessionExpiredGrid: {
		margin: "20px",
	},
	sessionExpiredButton: {
		color: colors.white,
		background: `${colors.primary} !important`,
		textTransform: "none",
		width: "120px",
		"&:hover": {
			backgroundColor: `${colors.darkCrimsonRed} !important`,
		},
	},
	sessionDialogTitle: {
		background: colors.primary,
		color: colors.white,
	},
	sessionActionContainer: {
		marginLeft: 15,
		marginRight: 15,
		marginBottom: 8,
		display: "flex",
		justifyContent: "flex-end",
		gap: 8,
	},
	sessionLogoutButton: {
		color: colors.charcoalGray,
		textTransform: "none",
		width: "120px",
		backgroundColor: `${colors.nearWhite} !important`,
		"&:hover": {
			backgroundColor: `${colors.warmOffWhite} !important`,
		},
	},
}));

export default QuestionnaireStyle;
